import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useAppDispatch } from '../../../store';
import { setIframeUnityDimensions } from '../../../store/features/wbml/wbmlSlice';
import { getSiteEnvironment } from '../../../util/environment';
import { AppLayoutContext } from '../AppRoot/AppRoot';
import './UnityPlayer.less';

const UnityPlayer = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { sidebarCollapsed } = useContext(AppLayoutContext);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const dispatch = useAppDispatch();

  useEffect(() => {
    const calculateDimensions = () => {
      const UNITY_TOOLBAR_WIDTH = 35;
      const sidebarWidth = sidebarCollapsed ? 80 : 250;
      const availableWidth =
        window.innerWidth - sidebarWidth - UNITY_TOOLBAR_WIDTH;
      const availableHeight = window.innerHeight - 68;

      setDimensions({
        width: availableWidth,
        height: availableHeight,
      });
    };

    calculateDimensions();
    window.addEventListener('resize', calculateDimensions);

    return () => {
      window.removeEventListener('resize', calculateDimensions);
    };
  }, [sidebarCollapsed]);

  useEffect(() => {
    if (iframeRef.current) {
      const dimensions = iframeRef.current.getBoundingClientRect();
      const iframeWidth = dimensions.width;
      const iframeHeight = dimensions.height;
      dispatch(
        setIframeUnityDimensions({ width: iframeWidth, height: iframeHeight })
      );
    }
  }, [dispatch]);

  const unityUrl = useMemo(() => {
    const timestamp = Date.now();
    const environment = getSiteEnvironment();
    const subdomain = environment === 'production' ? '' : `${environment}.`;

    return process.env.NODE_ENV === 'development'
      ? `/unity/unity.html?v=${timestamp}`
      : `https://portal.${subdomain}readysetvr.com/unity/unity.html?v=${timestamp}`;
  }, []);

  return (
    <div className="unity-player-wrapper">
      <iframe
        ref={iframeRef}
        src={unityUrl}
        title="Unity WebGL"
        className="unity-player"
        width={dimensions.width}
        height={dimensions.height}
      />
    </div>
  );
};

export default UnityPlayer;
